
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { environment } from '../../../../environments/environment';

export enum InputTypes {
  text = 'text',
  calendar = 'calendar',
  select = 'select'
}

@Component({
  selector: 'glo-control',
  imports: [MatFormFieldModule, MatInputModule, MatDatepickerModule, MatNativeDateModule, MatIconModule, CommonModule, NgSelectModule, FormsModule],
  templateUrl: './glo-control.component.html',
  styleUrls: ['./glo-control.component.scss']   // use styleUrls (array)
})
export class GloControlComponent {
  @Input() isDisabled: boolean = false;
  @Input() icon: string = '';
  @Input() placeholder: string = '';
  @Input() type: string = 'text';
  @Input() classes: string = '';
  @Input() rightIcon: string = '';
  @Input() showIcon: boolean = true;
  @Input() showKey: string = 'name';
  @Input() valueKey: string = 'id';
  @Input() options: any[] = [];
  @Input() value: any = null;

  @Output() valueChange = new EventEmitter<any>();

  assetUrl = environment.assetBaseUrl

  types = InputTypes;

  ngOnInit() {
    // Do NOT blindly set a default value from options (this caused unexpected behavior).
    // Leave `value` as-is; if you want a default, parent should pass it explicitly.
  }

  // Called by text inputs
  onInput(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.value = target.value;
    this.valueChange.emit(this.value);
  }

  // Called by ng-select (via template binding below)
  onNgModelChange(newValue: any) {
    this.value = newValue;
    this.valueChange.emit(newValue);
  }
}
